import {
  SystemStyleObject,
  StyleFunctionProps,
  createMultiStyleConfigHelpers,
} from '@chakra-ui/react';
import { cardAnatomy } from '@chakra-ui/anatomy';
import {
  ColorMode,
  getBoxSizingStyles,
  getBorderWidthToken,
  getTypographyToken,
} from '@allergan-data-labs/alle-elements-core';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle(
  ({ colorScheme }: Partial<StyleFunctionProps>) => {
    return {
      container: {
        ...getBoxSizingStyles(),
        backgroundColor: `${colorScheme}.Container/Neutral/Base`,
        color: `${colorScheme}.Text/Neutral/Default`,
        borderRadius: 'Small',
        borderColor: `${colorScheme}.Border/Neutral/Subtle 2`,
        borderWidth: '1px',
        boxShadow: 'none',
      },
      header: {
        padding: '16',
        ...getTypographyToken('Body/Medium/Medium'),
      },
      body: {
        padding: '16',
        ...getTypographyToken('Body/Small/Regular'),
        color: `${colorScheme}.Text/Neutral/Support`,
      },
      footer: {
        padding: '16',
        ...getTypographyToken('Body/Small/Regular'),
      },
    };
  }
);

export const getCardStyles = (colorMode: ColorMode): SystemStyleObject => ({
  cursor: 'pointer',
  _hover: {
    boxShadow: `Elevation/2`,
  },
  _active: {
    boxShadow: `Elevation/1`,
  },
  _focusVisible: {
    outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
    outlineStyle: 'solid',
    outlineWidth: getBorderWidthToken('Bold') || '4px',
    outlineOffset: '0px',
    boxShadow: 'none',
  },
});

export const CardTheme = defineMultiStyleConfig({ baseStyle });
